import { clsx } from "clsx";
import type React from "react";
import type { FC } from "react";

import { Callout } from "widgets";

import calloutStyle from "../../../../styles/callout.module.scss";

export interface FormErrorProps {
  //horizontalLayout?: boolean;
  children: React.ReactNode;
  tooltip?: string;
}

const FormError: FC<FormErrorProps> = (props) => {
  return (
    <Callout key={"error"} className={clsx(calloutStyle.oldError)}>
      {props.children}
    </Callout>
  );
};

export { FormError };
